import { SiteItemData } from "../../../../interfaces";
import { NewYnetTvVerticalDynamicMutam } from "./NewYnetTvVerticalDynamicMutam";

export interface categoryObj {
    id: string
    categoryColor: string
    name: string
}

interface NewYnetTvVerticalDynamicMutamComponentaProps {
    videoList: SiteItemData[]
    isTabVisible: boolean
    isTitleVisible: boolean
    isSubTitleVisible: boolean
    tabTitleText: string
    firstAdPlace: number
    maxAds: number
    repeatAds: number
    shouldDisplayMobileAds: boolean
    category: categoryObj
    domain: string
    showPrerollAds: boolean
    prerollOnVideoEntrance: boolean
    tabBackgroundColor: string
    twitterLink: string
    youtubeLink: string
    tiktokLink: string
    facebookLink: string
    whatsappLink: string
    instagramLink: string
    displayType: string
    isLTR:boolean
    languageCode:string
    analyticsTitle: string
}

export class NewYnetTvVerticalDynamicMutamComponenta extends React.Component<NewYnetTvVerticalDynamicMutamComponentaProps, {}>{
    public static siteScriptName = "NewYnetTvVerticalDynamicMutamComponenta";

    public render() {
        const { videoList, isTabVisible,isTitleVisible, isSubTitleVisible, tabTitleText, repeatAds, maxAds, firstAdPlace, shouldDisplayMobileAds, category, domain, showPrerollAds, prerollOnVideoEntrance, tabBackgroundColor, tiktokLink, whatsappLink, twitterLink, youtubeLink, facebookLink, instagramLink, displayType, isLTR, languageCode, analyticsTitle } = this.props;
        const classes = `${isLTR ? "newYnetTvVerticalDynamicMutamComponentaLtr" : "newYnetTvVerticalDynamicMutamComponenta"} ${displayType}`;

        return (
            <div className={classes} analytics_title={analyticsTitle}>
                <NewYnetTvVerticalDynamicMutam
                    videoList={videoList}
                    isTabVisible={isTabVisible}
                    isTitleVisible={isTitleVisible}
                    isSubTitleVisible={isSubTitleVisible}
                    tabTitleText={tabTitleText}
                    repeatAds={repeatAds}
                    maxAds={maxAds}
                    firstAdPlace={firstAdPlace}
                    shouldDisplayMobileAds={shouldDisplayMobileAds}
                    category={category}
                    domain={domain}
                    showPrerollAds={showPrerollAds}
                    tabBackgroundColor={tabBackgroundColor}
                    twitterLink={twitterLink}
                    youtubeLink={youtubeLink}
                    tiktokLink={tiktokLink}
                    facebookLink={facebookLink}
                    whatsappLink={whatsappLink}
                    instagramLink={instagramLink}
                    displayType={displayType}
                    isLTR={isLTR}
                    languageCode={languageCode}
                    prerollOnVideoEntrance={prerollOnVideoEntrance}
                />
            </div>
        )
    }
}
